import icStart from 'assets/images/ic-star.svg'
import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import { Spinner } from 'avo-ui'

export const UserSummary = ({ dataSummary, isLoading }) => {
    return (
        <div className={'flex justify-between p-6 rounded-xl bg-neutral-5'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center space-x-4'}>
                        <img
                            src={dataSummary?.profile_picture}
                            alt={'img-profile'}
                            className={'w-16 h-16 rounded-full'}
                        />
                        <div className={'flex flex-col space-y-2'}>
                            <p className={'text-lg font-bold capitalize'}>{dataSummary?.name}</p>
                            <p>{`Bergabung sejak ${formatDateMoment(dataSummary?.joined_at, 'DD MMM YYYY')}`}</p>
                            {dataSummary?.is_membership && (
                                <div className={'flex space-x-2'}>
                                    <img src={icStart} alt={'ic-start'} />
                                    <p className={'text-[#E53F58] font-bold'}>MSBB Membership</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={'flex items-center space-x-[62px]'}>
                        <div className={'flex flex-col'}>
                            <p className={'text-neutral-60 uppercase'}>Total Pesanan</p>
                            <p
                                className={'text-blue-90 text-lg font-bold'}
                            >{`${setNumberWithPoint(dataSummary?.total_order)} Pesanan`}</p>
                        </div>
                        <div className={'flex flex-col'}>
                            <p className={'text-neutral-60 uppercase'}>Total Ulasan</p>
                            <p
                                className={'text-blue-90 text-lg font-bold'}
                            >{`${setNumberWithPoint(dataSummary?.total_review)} Ulasan`}</p>
                        </div>
                        <div className={'flex flex-col'}>
                            <p className={'text-neutral-60 uppercase'}>Total Point</p>
                            <p
                                className={'text-blue-90 text-lg font-bold'}
                            >{`${setNumberWithPoint(dataSummary?.total_point)} Point`}</p>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
